document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetLimitNumber', function(limit) {
    // Modify default limit, then return a number
    return 50;
  });
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    if (hit.tags.indexOf('hide-search') > -1) {
      return;
    }

    var limit = 2;
    var label_count = 0;
    var label = '';

    if (label_count < limit && hit.meta.theme && hit.meta.theme.label != '') {
      label_count += 1;
      label = `
        <div class="product-label-wrapper flex">
          <span class="product-label product-label--custom">
            <svg class="icon icon--award" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
              <circle stroke="currentColor" fill="none" cx="8.1081667" cy="5.6658235" r="4.3742652"/>
              <polyline stroke="currentColor" fill="none" points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" transform="matrix(0.624895,0,0,0.624895,0.60942571,0.66666362)" />
            </svg>
            ${hit.meta.theme.label}
          </span>
        </div>
      `;
    }

    if (label_count < limit && hit.template_suffix.indexOf("preorder") > -1) {
      label_count += 1;
      label += `
        <div class="product-label-wrapper flex">
          <span class="product-label product-label--preorder">
            Pre-order
          </span>
        </div>
      `;
    }

    if (label_count < limit && hit.inventory_available != true) {
      label_count += 1;
      label += `
        <div class="product-label-wrapper flex">
          <span class="product-label product-label--sold-out">
            <svg class="icon icon--box" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
              <path fill="currentColor" d="M14.41 3.37L8.27 1.41a1 1 0 00-.61 0L1.52 3.37a1 1 0 00-.7.95v7.86c0 .41.25.78.63.93l6.14 2.46c.24.1.5.1.75 0l6.14-2.46a1 1 0 00.62-.93V4.32a1 1 0 00-.69-.95zM7.96 2.36l6.05 1.93-2.7.9L5.35 3.2l2.63-.84zm-.46 12.1l-5.68-2.28V5.3L7.5 7.2v7.26zM8 6.3L1.96 4.28l2.58-.82 5.99 2L8 6.3zm6.1 5.89l-5.6 2.24V7.19l5.6-1.87v6.87z"></path>
            </svg>
            Sold out
          </span>
        </div>
      `;
    }

    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${(event) => handleItemClick(event, hit)}"
      >
        <div class="ais-hit--image">
          <img
            class="ais-hit--picture"
            src="${algoliaShopify.helpers.largeImage(hit)}"
            alt="${hit.title} - ${hit.variant_title}"
          />
        </div>

        <div class="ais-hit--details">
          ${label && html`<div class="product-label-wrapper" dangerouslySetInnerHTML=${{
                __html: label
              }}>
              </div>`}
          <div class="yotpo-widget-instance" data-yotpo-instance-id="538897" data-yotpo-product-id="${hit.id}"></div>
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              onclick="void(0)"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p
            class="ais-hit--subtitle"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          <div
            class="ais-hit--sub-title"
          >
            ${hit.meta.descriptors?.subtitle && html`
              <span dangerouslySetInnerHTML=${{
                __html: hit.meta.descriptors?.subtitle
                  .replace(/\[/g, '')
                  .replace(/\]/g, '')
                  .replace(/"/g, '')
                  .replace(', Hair,', '<hair_placeholder>')
                  .replace(', Skin', '<skin_placeholder>')
                  .replace(', and', '<and_placeholder>')
                  .replace(/,/g, '<br>')
                  .replace('<hair_placeholder>', ', Hair,')
                  .replace('<skin_placeholder>', ', Skin')
                  .replace('<and_placeholder>', ', and')
              }}>
              </span>`
            }
          </div>
          <p class="ais-hit--price">
            From <b>$ ${hit.variants_min_price}</b>
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.compare_at_price
                    )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          ${!hit._distinct &&
            html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart">
                ${hit.can_order
                  ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
                  : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });

  // setTimeout(function () {
  //   yotpoWidgetsContainer.initWidgets();
  // }, 4000);
});
